import { Heading } from '../heading'
import { Text } from '../text/text.tsx'

export const BladeCheckoutItem = ({
  price,
  priceText,
}: {
  price?: string
  priceText?: string
  onRemove?: () => void
}) => {
  return (
    <>
      {priceText && (
        <Text
          textColor="tertiary"
          fontSize="2xs"
          fontWeight="semibold"
          className="uppercase leading-none"
        >
          {priceText}
        </Text>
      )}
      {price && (
        <Heading fontSize="xl" fontWeight="bold" className="leading-none">
          {price}
        </Heading>
      )}
    </>
  )
}
